<!--
   RSTI Facial Rekognition Auth UI
-->

<div ngClass="main" fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="center center" fxLayoutAlign.xs="start center">
  <router-outlet></router-outlet>
</div>